import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { ProfileSettingsModel } from './model/ProfileSettingsModel';
import { ProfileSettingsController } from './controller/ProfileSettingsController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem } from 'utils/Navigation';
import { Paper } from 'components/paper';
import { Button } from '@material-ui/core';
import { EditProfileDialog } from './EditProfileDialog';
import { ChangeImageDialog } from './ChangeImageDialog';

const FALLBACK_IMAGE = "/images/logo/logo_1000.png";

export class ProfileSettingsScene extends AScene<Props, ProfileSettingsModel, ProfileSettingsController> {

    public constructor(props: Props) {
        super(props);

        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleImageClicked = this.handleImageClicked.bind(this);
    }

    protected createControlller(): ProfileSettingsController {
        return new ProfileSettingsController();
    }

    private handleEditClicked() {
        this.controller.onEditProfileClicked();
    }

    private handleImageClicked() {
        this.controller.onChangeImageClicked();
    }

    public render(): React.ReactNode {
        if (this.model.isInit) {
            return (<></>);
        }
        return (
            <div style={{ width: '100%', padding: '80px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '600px' }}>
                    <Paper>
                        {this.renderAvatar()}

                        <div style={{ textAlign: 'center', fontSize: '22px', fontWeight: 700, color: '#222', marginTop: '16px' }}>{this.model.name}</div>
                        <div style={{ textAlign: 'center', fontSize: '18px', color: '#888', marginTop: '4px' }}>{this.model.position != null ? this.model.position : "Add your position"}</div>
                        <div style={{ textAlign: 'center', fontSize: '16px', color: '#aaa', marginTop: '4px' }}>{this.model.team != null ? this.model.team : "No team"}</div>

                        <div style={{ height: '40px' }}></div>

                        <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 800, color: '#888' }}>BIO</div>
                        <div style={{ textAlign: 'center', fontSize: '16px', color: '#aaa', marginTop: '8px', whiteSpace: 'pre-wrap' }}>{this.model.bio != null ? this.model.bio : "Add your BIO."}</div>

                        <div style={{ height: '40px' }}></div>

                        {this.renderContactLine("Email", this.model.email)}
                        {this.renderContactLine("Chat", this.model.chatAddress)}
                        {this.renderContactLine("Phone (work)", this.model.workPhone)}
                        {this.renderContactLine("Phone (home)", this.model.homePhone)}
                        {this.renderContactLine("Address", this.model.address)}
                        {this.renderContactLine("Member since", this.model.memberSince)}

                        <div style={{ height: '40px' }}></div>

                        <div style={{ width: '100%', textAlign: 'center' }}>
                            <Button variant="contained" style={{ backgroundColor: '#ff9800', color: '#fff' }} onClick={this.handleEditClicked}>Edit</Button>
                        </div>
                    </Paper>
                </div>

                {this.model.editProfileDialogModel != null && (
                    <EditProfileDialog model={this.model.editProfileDialogModel} controller={this.controller} />
                )}
                {this.model.changeImageDialogModel != null && (
                    <ChangeImageDialog model={this.model.changeImageDialogModel} controller={this.controller} />
                )}
            </div>
        );
    }

    private renderAvatar() {
        return (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <img
                    src={this.model.pictureUrl}
                    onClick={this.handleImageClicked}
                    onError={(e) => { (e.target as HTMLImageElement).src = FALLBACK_IMAGE; }}
                    style={{
                        width: '200px',
                        height: '200px',
                        borderRadius: '100px',
                        objectFit: 'cover',
                        border: '1px solid #ddd',
                        cursor: 'pointer'
                    }}
                />
            </div>
        );
    }

    private renderContactLine(title: string, value: string) {
        return (
            <div style={{ width: '100%', padding: '12px 0px', borderBottom: '1px solid #eee' }}>
                <div style={{ fontSize: '14px', color: '#009155' }}>{title}</div>
                <div style={{ fontSize: '18px', color: '#888' }}>{value != null ? value : ""}</div>
            </div>
        );
    }

}

export class Props {

}

export class ProfileSettingsSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return (
            <ProfileSettingsScene />
        );
    }

}
